// extracted by mini-css-extract-plugin
export default {"SliderInputBlock":"SliderInputBlockzc2Ob","sliderInputBlock":"SliderInputBlockzc2Ob"};